import { CIcon } from '~/icons/types'

export const ciTrekkingBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M5.1 18.42a4.1 4.1 0 1 1 4.1-4.1 4.104 4.104 0 0 1-4.1 4.1Zm0-7.254a3.154 3.154 0 1 0 3.154 3.154A3.157 3.157 0 0 0 5.1 11.166Zm13.8 7.254a4.1 4.1 0 1 1 4.1-4.1 4.104 4.104 0 0 1-4.1 4.1Zm0-7.254a3.154 3.154 0 1 0 3.154 3.154 3.157 3.157 0 0 0-3.154-3.154Zm-7.69 3.629a.473.473 0 0 1-.434-.284L7.814 7.709a.473.473 0 0 1 .867-.377l2.962 6.802a.473.473 0 0 1-.433.661Z'
    },
    {
      d:
        'M9.397 7.733h-.001L7.2 7.725a.473.473 0 0 1 .001-.945h.002l2.194.007a.473.473 0 0 1-.001.946Z'
    },
    {
      d:
        'M12.39 14.113a1.253 1.253 0 1 1-1.257-1.258 1.255 1.255 0 0 1 1.258 1.258Z'
    },
    {
      d:
        'M11.138 14.793H5.1a.472.472 0 0 1-.355-.785L8.77 9.44a.472.472 0 1 1 .71.624l-3.333 3.784h4.834l4.058-3.054-4.968 1.131a.472.472 0 1 1-.21-.921l7.125-1.622a.473.473 0 0 1 .389.838l-5.951 4.478a.473.473 0 0 1-.285.095Z'
    },
    {
      d:
        'M5.129 14.672a.447.447 0 0 1-.07-.005.472.472 0 0 1-.398-.537 5.304 5.304 0 0 0-.338-2.982 3.305 3.305 0 0 0-2.094-1.863.474.474 0 0 1-.351-.406l-.027-.238a.472.472 0 0 1 .47-.524h6.28a.473.473 0 0 1 0 .945H3.854a4.535 4.535 0 0 1 1.328 1.693 6.238 6.238 0 0 1 .414 3.514.473.473 0 0 1-.467.403Zm13.557.124a.473.473 0 0 1-.445-.314l-1.998-5.608a.459.459 0 0 1-.014-.038l-.935-2.625a.473.473 0 0 1 .445-.632h3.724a.473.473 0 0 1 0 .946H16.41l.605 1.699h3.514a.473.473 0 0 1 .45.62l-1.844 5.626a.473.473 0 0 1-.443.326Zm-1.334-5.627 1.315 3.693 1.21-3.693Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'trekking-bike',
  type: 'thin'
}
